import Link from 'next/link'
import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

import Engraving from '@components/product/Engraving'
import {
  GENERAL_ENGRAVING,
  GENERAL_QUICK_VIEW,
  IMG_PLACEHOLDER,
  ITEM_TYPE_ADDON,
} from '@components/utils/textVariables'
import { removePrecedingSlash, removeSucceedingSlug } from '@framework/utils/app-util'
import { round } from '@framework/utils/lodash'
import { priceFormat } from '@framework/utils/parse-util'
import { FreeMode } from 'swiper'
import { useUI } from '@components/ui'
import SwiperCore, { Navigation } from 'swiper'
import { useRouter } from 'next/router'

interface Attribute {
  fieldName?: string
  fieldCode?: string
  fieldValues?: []
}

interface IProps {
  isOnlyMobile: boolean
  relatedProductGroup: any
  pageType: string
  viewProductDetail: (product: any, pid: number) => void
  onProductQuickView: (product: any, pid: number) => void
  handleWishList: (product: any) => void
  addToCart: (product: any) => void
}

SwiperCore.use([Navigation])
const colorKey = 'global.colour'

const RelatedProductsWithGroupSection = ({
  isOnlyMobile,
  relatedProductGroup,
  pageType,
  addToCart,
  viewProductDetail,
  onProductQuickView,
  handleWishList,
}: IProps) => {
  const { wishListItems } = useUI()
  const [isEngravingOpen, showEngravingModal] = useState(false)
  const router = useRouter()
  return (
    <section
      aria-labelledby="related-heading"
      className={`px-4 pr-0 ${
        isOnlyMobile ? 'pl-0' : ''
      } sm:px-0 alsolike-container`}
    >
      {Object.entries(relatedProductGroup)
        ?.sort((a: any, b: any) => a.displayOrder - b.displayOrder)
        ?.map(([key, values]: any, iid: number) => {
          return (
            // key != 'Quickly Add' && (
            key === 'You May Also Like' &&
            key != 'undefined' && (
              <div key={`product-${iid}-related-with-group`}>
                <div
                  className={`flex flex-col mb-2 sm:mb-6 ${
                    isOnlyMobile ? 'pl-4' : ''
                  } `}
                >
                  <h3 className="text-2xl font-bold capitalize text-dark-brown">
                    {key}
                  </h3>
                </div>
                <div className="default-sm mobile-slider-no-arrow m-hide-navigation sm:mb-6">
                  <Swiper
                    slidesPerView={2.3}
                    spaceBetween={8}
                    navigation={true}
                    loop={false}
                    freeMode={true}
                    modules={[FreeMode]}
                    breakpoints={{
                      640: {
                        slidesPerView: 2.3,
                        spaceBetween: 4,
                      },
                      768: {
                        slidesPerView: 3.3,
                        spaceBetween: 15,
                      },
                      1024: {
                        slidesPerView: 5.5,
                        spaceBetween: 15,
                      },
                    }}
                    className="mySwiper"
                  >
                    {values?.map((product: any, pid: number) => {
                      const isEngravingAvailable =
                        product.stockCode === ITEM_TYPE_ADDON
                      const saving =
                        product?.price?.maxPrice - product?.price?.minPrice
                      const discount = round(
                        (saving / product?.price?.maxPrice) * 100,
                        0
                      )

                      return (
                        <SwiperSlide
                          key={`product-${pid}-swiper-new-slider`}
                          className={pid === 0 && isOnlyMobile ? 'cs-mr-1' : ''}
                        >
                          <div className="grid w-full grid-cols-1 text-left">
                            <div className="relative">
                              <div className="imae-container">
                                <Link
                                  legacyBehavior
                                  href = {`/${removeSucceedingSlug(product?.slug)}/[slug]`}
                                  as={`/${removePrecedingSlash(product?.slug )}`}
                                  passHref
                                >
                                  <a
                                    onClick={(ev: any) => {
                                      ev.preventDefault()
                                      viewProductDetail(product, pid)
                                      router.push(`/${removePrecedingSlash(product?.slug)}`)
                                    }}
                                  >
                                    <img
                                      src={product?.image || IMG_PLACEHOLDER}
                                      alt={product?.name}
                                      width={284}
                                      height={505}
                                      className="object-cover object-center w-full h-full radius-xs sm:h-full"
                                    />
                                  </a>
                                </Link>
                              </div>
                              {pageType === 'PDP' ? (
                                <>
                                  <div className="grid grid-cols-12 px-2 sm:grid-cols-12 sm:gap-x-2 hf-23px">
                                    <div className="col-span-8 text-left sm:col-span-8 hf-28px">
                                      <h5 className="w-11/12 py-1 overflow-hidden font-normal truncate text-10 text-brown-light dark:text-brown-light sm:text-10 sm:group-hover:hidden fh-24">
                                        {product?.classification?.category}
                                      </h5>
                                    </div>
                                    {product?.rating > 0 && (
                                      <div className="col-span-4 text-right sm:col-span-4">
                                        <i className="sprite-icon sprite-star"></i>
                                        <span className="ml-1 font-semibold text-12 text-primary dark:text-primary">
                                          {product?.rating}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="relative px-0 text-left">
                                    <h3
                                      className="px-2 py-1 overflow-hidden font-medium text-12 text-primary dark:text-primary sm:text-12 sm:group-hover:hidden hf-48px fh-28 ipd-visible"
                                      title={product?.name}
                                    >
                                      <Link
                                        legacyBehavior
                                        href={`/${removePrecedingSlash(
                                          product?.slug
                                        )}`}
                                        passHref
                                      >
                                        <a
                                          href={`/${removePrecedingSlash(
                                            product?.slug
                                          )}`}
                                          onClick={() =>
                                            viewProductDetail(product, pid)
                                          }
                                          className="text-truncate-two-lines"
                                        >
                                          {product?.name}
                                          {/* {truncate(
                                            product?.name,
                                            getWordBreakLimit
                                          )} */}
                                        </a>
                                      </Link>
                                    </h3>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="grid grid-cols-12 px-2 sm:grid-cols-12 sm:gap-x-2">
                                    <div className="col-span-8 text-left sm:col-span-8 hf-28px">
                                      <h5 className="w-11/12 py-1 overflow-hidden font-normal truncate text-10 text-brown-light dark:text-brown-light sm:text-10 sm:group-hover:hidden fh-24">
                                        {product?.classification?.category}
                                      </h5>
                                    </div>
                                    {product?.rating > 0 && (
                                      <div className="col-span-4 text-right sm:col-span-4">
                                        <i className="sprite-icon sprite-star"></i>
                                        <span className="ml-2 font-semibold text-12 text-primary dark:text-primary">
                                          {product?.rating}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="relative px-0 text-left">
                                    <h3 className="w-11/12 px-2 py-1 overflow-hidden font-medium truncate text-12 text-primary dark:text-primary sm:text-12 sm:group-hover:hidden fh-28 ipd-visible">
                                      <Link
                                        legacyBehavior
                                        href={`/${product?.slug}`}
                                        passHref
                                      >
                                        <a
                                          href={`/${product?.slug}`}
                                          onClick={() =>
                                            viewProductDetail(product, pid)
                                          }
                                        >
                                          {product?.name}
                                        </a>
                                      </Link>
                                    </h3>
                                  </div>
                                </>
                              )}

                              <div className="flex px-2">
                                <p className="mt-1 mb-2 font-medium text-left text-primary xs-text-10 text-12 sm:mt-1 sm:group-hover:hidden sm:mb-0">
                                  {priceFormat(product?.price?.minPrice)}
                                  {discount > 0 ? (
                                    <>
                                      <span className="px-2 font-normal text-gray-400 line-through xs-text-10 text-12">
                                        {priceFormat(product?.price?.maxPrice)}
                                      </span>
                                      <span className="inline-block xs-text-10 text-12 text-green">
                                        {discount}% off
                                      </span>
                                    </>
                                  ) : null}
                                </p>
                              </div>
                            </div>
                            <div className="flex justify-around px-1 mt-2">
                              {wishListItems
                                .map((wi: any) => wi?.recordId)
                                .includes(product?.recordId) ? (
                                <div className="relative flex items-center justify-center px-3 py-2 -mr-1 text-sm font-medium bg-white border border-gray-300 sm:px-6 btn-basic-property text-dark-brown add-wishlist">
                                  <i className="sprite-icon sprite-o-whislist"></i>
                                </div>
                              ) : (
                                <button
                                  className="relative flex items-center justify-center px-3 py-2 -mr-1 text-sm font-medium bg-white border border-gray-300 sm:px-6 btn-basic-property text-dark-brown hover:bg-orange-400"
                                  onClick={() => handleWishList(product)}
                                >
                                  <i className="sprite-icon sprite-whislist"></i>
                                  <span className="text-sm font-medium text-gray-700 hover:text-red-800"></span>
                                  <span className="sr-only">f</span>
                                </button>
                              )}
                              <button
                                onClick={() => onProductQuickView(product, pid)}
                                type="button"
                                className="relative flex items-center justify-center w-full px-1 py-2 text-xs font-medium text-black bg-white border border-gray-300 sm:text-sm btn-basic-property hover:bg-black hover:text-white"
                              >
                                {GENERAL_QUICK_VIEW}
                              </button>
                              <Link
                                legacyBehavior
                                href={`/${removePrecedingSlash(product?.slug)}`}
                                passHref
                              >
                                <span className="sr-only">
                                  , {product.name}
                                </span>
                              </Link>
                              {isEngravingAvailable && (
                                <>
                                  <button
                                    className="relative flex items-center justify-center w-full py-2 mt-2 text-sm font-medium text-white bg-gray-400 border border-transparent rounded-md btn-basic-property hover:bg-gray-500"
                                    onClick={() => showEngravingModal(true)}
                                  >
                                    <span className="font-bold">
                                      {GENERAL_ENGRAVING}
                                    </span>
                                  </button>
                                  <Engraving
                                    show={isEngravingOpen}
                                    submitForm={() => addToCart(product)}
                                    onClose={() => showEngravingModal(false)}
                                  />
                                </>
                              )}
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                </div>
              </div>
            )
          )
        })}
    </section>
  )
}

export default RelatedProductsWithGroupSection
